import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["onClick", "data-qa"]
const _hoisted_2 = ["href", "data-qa"]
const _hoisted_3 = {
  key: 1,
  class: "_flex _gap-1"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_router_link = _resolveComponent("router-link")
  const _component_base_balloon = _resolveComponent("base-balloon")
  const _component_click_outside = _resolveComponent("click-outside")
  const _component_floating_content = _resolveComponent("floating-content")

  return (_openBlock(), _createElementBlock("div", null, [
    ($options.isInGroupedMode)
      ? (_openBlock(), _createBlock(_component_floating_content, {
          key: 0,
          "is-content-visible": _ctx.isBalloonVisible,
          single: true,
          "vertical-position": $options.balloonProps.direction,
          position: $options.balloonProps.position,
          "content-wrapper-class": "_pa-1",
          onClose: $options.onBalloonClose
        }, {
          trigger: _withCtx(() => [
            _createVNode(_component_base_button, {
              shape: "circle",
              "aria-label": _ctx.Resources.Common.BalloonActionsTriggerLabel,
              theme: $props.theme,
              onClick: $options.onBalloonToggle,
              onMouseenter: $options.onMouseEnterTrigger,
              onMouseleave: $options.onMouseLeaveTrigger,
              "data-qa": "circle-menu"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_icon, { name: "ellipsis-v" })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["aria-label", "theme", "onClick", "onMouseenter", "onMouseleave"])
          ]),
          content: _withCtx(() => [
            (_ctx.isBalloonVisible)
              ? (_openBlock(), _createBlock(_component_click_outside, {
                  key: 0,
                  call: $options.onClickOutside,
                  "is-enabled": _ctx.isClickOutsideEnabled
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_balloon, _mergeProps($options.balloonProps, { class: "_px-2 _py-2" }), {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.items, (item) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (item.hasAction)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: `${item.title}-action`,
                                  class: _normalizeClass($options.itemClasses(item)),
                                  onClick: _withModifiers(() => $options.onAction(item.fn), ["prevent"]),
                                  "data-qa": `balloon-action:${item.qa}`
                                }, [
                                  _createVNode(_component_base_icon, {
                                    class: "gfu-balloon__content-icon",
                                    name: item.icon
                                  }, null, 8 /* PROPS */, ["name"]),
                                  _createTextVNode(" " + _toDisplayString(item.title), 1 /* TEXT */)
                                ], 10 /* CLASS, PROPS */, _hoisted_1))
                              : (item.to)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: `${item.title}-router-link`,
                                    to: item.to,
                                    class: _normalizeClass($options.itemClasses(item)),
                                    "data-qa": `balloon-action:${item.qa}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_base_icon, {
                                        class: "gfu-balloon__content-icon",
                                        name: item.icon
                                      }, null, 8 /* PROPS */, ["name"]),
                                      _createTextVNode(" " + _toDisplayString(item.title), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "class", "data-qa"]))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: `${item.title}-link`,
                                    href: item.url,
                                    class: _normalizeClass($options.itemClasses(item)),
                                    "data-qa": `balloon-action:${item.qa}`
                                  }, [
                                    _createVNode(_component_base_icon, {
                                      class: "gfu-balloon__content-icon",
                                      name: item.icon
                                    }, null, 8 /* PROPS */, ["name"]),
                                    _createTextVNode(" " + _toDisplayString(item.title), 1 /* TEXT */)
                                  ], 10 /* CLASS, PROPS */, _hoisted_2))
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }, 16 /* FULL_PROPS */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["call", "is-enabled"]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["is-content-visible", "vertical-position", "position", "onClose"]))
      : ($options.isInInlineMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.items, (action) => {
              return (_openBlock(), _createBlock(_component_base_button, {
                key: action.title,
                shape: "circle",
                theme: $props.theme,
                class: _normalizeClass(action.classes),
                enabled: action.isEnabled,
                onClick: () => $options.onAction(action.fn),
                "data-qa": `action:${action.qa}`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_icon, {
                    name: action.icon
                  }, null, 8 /* PROPS */, ["name"])
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["theme", "class", "enabled", "onClick", "data-qa"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
  ]))
}